import React from 'react';
import PageMeta from '../../components/common/PageMeta';
import FooterOne from '../../layout/Footer/FooterOne';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
import CookieHeroSection from './cookieHeroSection';

const Cookie = () => {
    return (
        <Layout >
            <div
                style={{ background: "radial-gradient(75% 25% at 50% 0%, rgb(216 223 235), rgb(255, 255, 255))" }}
            >
                <PageMeta />
                <Navbar />

                <section
                    className='page-header position-relative overflow-hidden pt-60 pb-60 '
           
                >
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12'>
                                <div className='text-center'>
                                    <h1 className=' fw-bold'>Cookie policy</h1>
                                    <p className='lead'>
                                        This cookie policy explains how Senertech Software Private Limited (“Senertech”, “company”, “we”, “us”, and “our”) uses cookies and similar technologies to recognise you when you visit our website at https://www.senertech.in (“website”) and/or all subdomains. It explains what these technologies are and why we use them, as well as your rights to control our use of them. <br /><br />

                                        In some cases, we may use cookies to collect personal information, or that becomes personal information if we combine it with other information.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <CookieHeroSection />
                <FooterOne
                    style={{
                        background:
                            "url('assets/img/page-header-bg.svg')no-repeat bottom left",
                    }}
                />
            </div>
        </Layout>
    );
};

export default Cookie;
